import React from 'react';
import { InputLabelBase } from '../../../../../../../components/inputs/InputLabelBase';

interface Props extends React.ComponentProps<typeof InputLabelBase> {
  children?: React.ReactNode;
}

const CoverageOptionsLabel = ({ children, ...props }: Props) => {
  return (
    <InputLabelBase style={{ padding: 0 }} {...props}>
      {children}
    </InputLabelBase>
  );
};

export default CoverageOptionsLabel;
